import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局注册图标
Vue.use(ElementUI);
import VCharts from 'v-charts'
Vue.use(VCharts)
// 适配flex
import '@/common/flexible.js';
import './assets/scss/style.scss';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import VueLoopScroll from 'vueloopscroll'
import 'vueloopscroll/lib/vueloopscroll.css';
Vue.use(VueLoopScroll)
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
